<template>
  <div>
    <div class="noprint">
      <AdminHeader></AdminHeader>
      <section class="admin-back">
        <div>
          <i class="fa fa-angle-left"></i>
          <router-link to="/admin/orderList">返回訂單總覽</router-link>
        </div>
        <div class="btn-container">
          <button v-if="isLayoutConfirmButtonDisplay" @click="lightboxControl('typesetting-confirm')">製版確認</button>
          <button v-if="isShippingNotificationButtonDisplay" @click="lightboxControl('order-shipped')" id="order-shipped">出貨通知</button>
          <button class="last-btn" @click="seltPickupFinish" v-if="orderDetail.send_way === '自取'">自取完成</button>
          <button class="last-btn" @click="mailInfoPrint" v-if="orderDetail.send_way !== '自取'">郵寄資訊列印</button>
        </div>
      </section>
      <div id="admin-orderDetail-container" v-if="isImagefinish">
        <section class="admin-order-title">
          <div class="flex-item">
            <div>
              <span class="bold-word">訂單編號：{{orderDetail.trade_no}}</span>
            </div>
            <div>
              <span class="bold-word">訂購時間：{{orderDetail.created_at}}</span>
            </div>
            <div>
              <span class="bold-word" v-if="orderDetail.is_shipped === '1'">訂單狀態：已完成</span>
              <span class="bold-word" v-else-if="orderDetail.is_paid === '1'">訂單狀態：未出貨</span>
              <span class="bold-word" v-else>訂單狀態：未付款</span>
            </div>
            <div>
              <span class="bold-word" v-if="orderDetail.is_shipped=== '1'">出貨時間：{{orderDetail.shipped_at}}</span>
              <span class="bold-word" v-else>出貨時間：----</span>
            </div>
          </div>
          <div class="flex-item">
            <button v-on:click="deleteOrders">刪除訂單</button>
          </div>
        </section>
        <section class="admin-order-info">
          <div class="flex-item">
            <p class="bold-word">寄送資訊</p>
            <div>
              <span>寄送地區 ：{{orderDetail.country}}</span>
            </div>
            <div>
              <span>寄送地址 ：{{orderDetail.postal_code}}{{orderDetail.address}}</span>
            </div>
            <div>
              <span>寄送方式 ：{{orderDetail.send_way}}</span>
            </div>
            <div v-if="orderDetail.is_paid === '1' && orderDetail.send_way !== '自取'">
              <div>
                <span>郵局單號 ：</span>
                <span v-if="orderDetail.postal_trace_code">{{orderDetail.postal_trace_code}}</span>
                <div v-else>
                  <input type="text" v-model="postalTradeCode">
                  <button @click="sendPostalTradeCode">送出</button>
                </div>
              </div>
              <div>
                <span>郵件資費 ：</span>
                <span v-if="orderDetail.postal_cost !== null">{{orderDetail.postal_cost}}</span>
                <div v-else>
                  <input type="text" v-model="postalCost">
                  <button @click="sendPostalCost">送出</button>
                </div>
              </div>
            </div>
          </div>
          <div class="flex-item">
            <p class="bold-word">收貨人資訊</p>
            <div>
              <span>收件人 ：{{orderDetail.full_name}}</span>
            </div>
            <div>
              <span>手機 ：{{orderDetail.phone}}</span>
            </div>
            <div>
              <span>電子信箱 ：{{orderDetail.email}}</span>
            </div>
          </div>
          <div v-if="this.orderDetail.invoice_type =='同業'" class="flex-item">
            <p class="bold-word">特約資訊</p>
            <div>
              <span>名稱：{{orderDetail.user.special_member.company_company_name}}</span>
            </div>
            <div>
              <span>聯絡地址：{{orderDetail.user.special_member.company_address}}</span>
            </div>
            <div>
              <span>負責人 ：{{orderDetail.user.special_member.principal_name}}</span>
            </div>
            <div>
              <span>電話 ：{{orderDetail.user.special_member.principal_phone}}</span>
            </div>
            <div>
              <span>信箱 ：{{orderDetail.user.special_member.principal_email}}</span>
            </div>
            <div>
              <span>LINE ID：{{orderDetail.user.special_member.principal_line_id}}</span>
            </div>
          </div>
          <div v-else class="flex-item">
            <p class="bold-word">發票資訊</p>
            <div>
              <span>發票種類 ：{{orderDetail.invoice_type}}</span>
            </div>
            <div>
              <span>抬頭 ：{{orderDetail.invoice_head}}</span>
            </div>
            <div>
              <span>統一編號 ：{{orderDetail.invoice_num}}</span>
            </div>
          </div>
        </section>
        <section class="admin-order-list">
          <div>
            <p class="bold-word">商品清單</p>
            <div class="flex-container">
              <div class="order-list-title">
                <div class="img-title">
                  <span>商品縮圖</span>
                </div>
                <div class="name-title">
                  <span>商品名稱</span>
                </div>
                <div class="number-title">
                  <span>商品編號</span>
                </div>
                <div class="quantity-title">
                  <span>數量</span>
                </div>
                <div class="price-title">
                  <span>金額(金價+工錢+配件)</span>
                </div>
              </div>
            </div>
            <div class="flex-container" v-for="(item,index) in products" :key="index">
              <div class="order-wrap">
                <div class="item-img">
                  <img v-bind:src="item.image_url" alt="item">
                </div>
                <div class="item-name">
                  <span>{{item.way}}-{{item.style}}</span>
                  <span>{{item.length}}{{item.unit}}{{item.weight}}錢 (配件選擇: {{item.accessory_name !== null?item.accessory_name:'無'}} - TWD {{item.accessory_price!== null?item.accessory_price:0}})</span>
                </div>
                <div class="item-number">
                  <span>{{item.productCode}}</span>
                </div>
                <div class="item-quantity">
                  <span>{{item.amount}}</span>
                </div>
                <div class="item-price">
                  <span>TWD {{singleProductSum(item.productPrice,item.accessory_price,
                    item.amount)}}({{item.gold_price}}+{{item.gold_fee}}+{{accessoryTotalPrice(item.accessory_price,
                    item.amount)}})</span>
                </div>
              </div>
              <div class="item-button">
                <button v-on:click="goToPrint(index)">大圖列印</button>
              </div>
            </div>
            <div class="total-amount">
              <span>訂單總金額</span>
              <span class="bold-word">TWD {{orderDetail.sum}}</span>
            </div>
            <div class="order-note">
              <p class="bold-word">訂單備註</p>
              <p>{{orderDetail.note}}</p>
            </div>
          </div>
        </section>
        <section class="all-lightbox">
          <div v-if="isClickTypesettingConfirmBtn" class="lightbox" v-bind:class="{'displaynone':closeLightbox}">
            <div class="lightbox-target">
              <p class="title"> 製版確認通知</p>
              <div class="mail-content-container">
                <div>信件內容：</div>
                <div class="content-container">
                  <div class="content-item">
                    <div>訂單號碼 : {{orderDetail.trade_no}}</div>
                    <p>親愛的 {{orderDetail.full_name}} 您好：</p>
                    <p>以下為正式製作的稿件，如有問題請儘速聯絡金牌王國，商品出貨後恕不退貨。</p>
                  </div>
                </div>
                <div class="upload-image-container">
                  <div v-if="isUploadFileIng">上傳中...</div>  
                  <div v-else-if="finishUploadFileData.fileName.length===0" class="no-files-text">未選取任何檔案</div>  
                  <ul>
                    <li v-for="(fileData,index) in finishUploadFileData.fileName" :key="index"><span>{{ fileData }}</span><span class="close"><img src="@/images/icon-close@2x.png" alt="close" @click="deleteUploadFile(index)"></span></li>
                  </ul>
                  <div class="upload-image-btn-container">
                    <label class="upload-image-btn" for="upload-file">上傳圖檔</label>
                    <input type="file" id="upload-file" multiple @change="userUploadFile">
                  </div>
                </div>
                <div class="sent-btn-container">
                  <button class="sent-btn" @click="sendLayoutCheckMail">確定寄出</button>
                </div>
              </div>
              <div class="lightbox-close" @click="closeLightbox=!closeLightbox">
                <img src="@/images/admin-lightbox-cross.png" alt="close">
              </div>
            </div>
          </div>
          <div v-else class="lightbox" v-bind:class="{'displaynone':closeLightbox}">
            <div class="lightbox-target">
              <p class="title" v-if="isClickPriceNotifyBtn"> 報價通知信件</p>
              <p class="title" v-else> 出貨通知信件</p>
              <div class="mail-content-container">
                <div>信件內容：</div>
                <div class="content-container">
                  <div class="content-item">
                    <div>訂單號碼 : {{orderDetail.trade_no}}</div>
                    <p>親愛的 {{orderDetail.full_name}},您的訂單已經寄出囉！</p>
                  </div>
                  <div class="content-item">
                    <div>
                      <div>收件地址：</div>
                      <div>{{orderDetail.full_name}}</div>
                      <div>{{$store.getters.getCityByZipcode(orderDetail.postal_code)}}{{orderDetail.address}}</div>
                      <div>{{orderDetail.country}}</div>
                    </div>
                  </div>
                  <div class="content-item">
                    <div>商品項目：</div>
                    <div v-for="(item ,index) in products" :key="index">
                      <div>名稱：{{item.way}}-{{item.style}}{{item.length}}{{item.unit}}{{item.weight}}錢(配件選擇: {{item.accessory_name !== null?item.accessory_name:'無'}} - TWD {{item.accessory_price!== null?item.accessory_price:0}})</div>
                      <div>數量：{{item.amount}}</div>
                      <div>金額：TWD {{singleProductSum(item.productPrice,item.accessory_price,
                    item.amount)}}</div>
                    </div>
                  </div>
                  <div class="content-item">
                    <div>小計：TWD {{orderDetail.sum}}</div>
                    <div>運費：TWD {{orderDetail.freight}}</div>
                    <div>總計：TWD {{orderDetail.sum}}</div>
                  </div>
                  <div class="content-item">
                    <div>
                      <div>您的包裹追蹤號碼: {{orderDetail.postal_trace_code}}</div>
                      <div>請由<a class="ChunghwaPostCo" href="http://postserv.post.gov.tw/pstmail/main_mail.html?targetTxn=EB500100">中華郵政網站</a>做查詢</div>
                      <div>如果您有任何問題，請來電或到門市與我們電話聯絡</div>
                      <div>電話：06-226-6300</div>
                      <div>專線電話：0986-669-288</div>
                      <div>地址：台南市西門路二段263號</div>
                      <div>金牌王國網址：<a href="https://kingdom9999.tw">https://kingdom9999.tw</a></div>
                    </div>
                  </div>
                </div>
                <div class="sent-btn-container">
                  <button class="sent-btn" v-on:click="sendNotice" :disabled="sendmailButtonisDisable">確定寄出</button>
                </div>
              </div>
              <div class="lightbox-close" @click="closeLightbox=!closeLightbox">
                <img src="@/images/admin-lightbox-cross.png" alt="close">
              </div>
            </div>
          </div>
        </section>
      </div>
      <div class="load" v-else>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
      </div>
    </div>
    <AdminPrint v-if="printType === 'image'" id="print"></AdminPrint>
    <AdminPrintPostCoMailingInfo v-if="printType === 'mailInfo'" :printMailData="printMailData" id="print"></AdminPrintPostCoMailingInfo>
    <div class="print" v-if="printPrepare">列印準備中，請稍後...<i class="fa fa-print"></i></div>
  </div>
</template>

<script>
import axios from "axios";
import AdminHeader from "@/components/admin/admin_header.vue";
import AdminPrint from "@/views/admin/admin_print.vue";
import AdminPrintPostCoMailingInfo from "@/views/admin/admin_printPostCoMailingInfo.vue";

export default {
  name: "adminOrderDetail",
  components: {
    AdminHeader,
    AdminPrint,
    AdminPrintPostCoMailingInfo
  },
  created() {
    this.getOrder();
  },
  data() {
    return {
      //先給defult值
      orderDetail: {
        orderId: "--",
        orderStatus: {
          createTime: "--",
          shippedTime: "--"
        },
        receiverInfo: {
          invoiceType: "--"
        }
      },
      products: "",
      isImagefinish: false,
      closeLightbox: true,
      postalTradeCode: "",
      postalCost: "",
      printPrepare: false,
      //image、invoice、mailInfo
      printType: "",
      isClickPriceNotifyBtn: false,
      isClickTypesettingConfirmBtn: false,
      sendmailButtonisDisable: false,
      //上傳圖檔
      uploadBlobData: "",
      uploadRemoteData: "",
      isUploadFileIng: false,
      finishUploadFileData: {
        urls: "",
        fileName: []
      },
      printMailData: []
    };
  },
  watch: {
    printLoading() {
      if (this.printLoading) {
        //定時器
        setTimeout(this.print, 1000);
        this.printPrepare = false;
      }
    },
    products: {
      handler() {
        if (typeof this.products !== "undefined") {
          //check img loading
          let checkNum = 0;
          this.products.forEach(item => {
            if (item.image_url.substring(0, 4) == "data") {
              checkNum = checkNum + 1;
            }
          });
          if (checkNum == this.products.length) {
            this.isImagefinish = true;
          }
        }
      },
      deep: true
    }
  },
  methods: {
    getOrder() {
      let orderId = this.$route.params.id;
      axios({
        url: this.$store.getters.getGlobalUrl + "admin/orders/" + orderId,
        method: "get",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `Bearer ${this.$store.getters.getBackstageToken}`
        }
      })
        .then(response => {
          this.orderDetail = response.data.data;
          this.products = response.data.data.order_items;
          this.products.forEach(item => {
            item.productCode = this.transformProductCode(
              {
                unit: item.unit,
                length: item.length,
                weight: item.weight,
                way: item.way
              },
              item.style
            );
            item.gold_fee = item.gold_fee * item.amount;
            item.gold_price = item.gold_price * item.amount;
            item.productPrice =
              parseInt(item.gold_fee) + parseInt(item.gold_price);
            item.way = this.$store.getters.getTransformWay(item.way);
            item.unit = this.$store.getters.getTransformUnit(item.unit);
          });
          this.baseToImg();
        })
        .catch(e => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    print() {
      window.print();
    },
    transformProductCode(size, style) {
      let productCode = "";
      let way = "",
        code = "",
        length = "",
        weight = "";

      way = size.way;

      let styleSheet = this.$store.getters.customizeMetalData;
      styleSheet.forEach(item => {
        if (item.name == style) {
          code = item.code;
        }
      });

      if (isNaN(Math.floor(size.length))) {
        // 尺寸為 S,M 系列
        length = size.length.substr(0, 1);
      } else {
        length =
          size.unit == "cm"
            ? this.zeroFill(Math.floor(size.length).toString(), 3)
            : this.zeroFill(Math.floor(size.length * 3).toString(), 3);
      }

      weight = this.zeroFill(
        [...size.weight].filter(item => item !== ".").join(""),
        5
      );

      productCode = `${way}${code}-${length}-${weight}`;

      return productCode;
    },
    zeroFill(now, fillLength) {
      if (now.length < fillLength) {
        let fillNum = fillLength - now.length + 1;
        return new Array(fillNum).join("0").concat(now);
      }
      return now;
    },
    baseToImg() {
      this.products.forEach(item => {
        axios({
          url: `${item.image_url}`,
          method: "get"
        })
          .then(response => {
            item.image_url = response.data;
          })
          .catch(e => {
            alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
          });
      });
    },
    lightboxControl(btnName) {
      this.closeLightbox = !this.closeLightbox;
      this.isClickPriceNotifyBtn = false;
      this.isClickTypesettingConfirmBtn = false;
      if (btnName === "price-notify") {
        this.isClickPriceNotifyBtn = true;
      } else if (btnName === "typesetting-confirm") {
        this.isClickTypesettingConfirmBtn = true;
      } else {
        this.isClickPriceNotifyBtn = false;
      }
    },
    sendPostalTradeCode() {
      let orderId = this.$route.params.id;
      axios({
        url:
          this.$store.getters.getGlobalUrl +
          `admin/orders/${orderId}/postal-trade-code`,
        method: "patch",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        data: { postalTradeCode: this.postalTradeCode }
      })
        .then(() => {
          alert("郵局單號更新成功");
          this.getOrder();
        })
        .catch(e => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    async sendPostalCost() {
      if (parseInt(this.postalCost).toString() === "NaN") {
        alert("請輸入數字");
        return;
      }
      try {
        await this.$store.dispatch("updatePostalCost", {
          id: this.$route.params.id,
          updateCostData: {
            postal_cost: this.postalCost
          }
        });
        alert("郵件資費更新成功");
        this.getOrder();
      } catch (e) {
        alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
      }
    },
    sendNotice() {
      this.sendmailButtonisDisable = true;
      let userResponse = "";
      let url = "";
      let orderId = this.$route.params.id;
      if (this.isClickPriceNotifyBtn) {
        (url =
          this.$store.getters.getGlobalUrl +
          `admin/orders/${orderId}/quoted-price`),
          (userResponse = confirm("您確定要送出報價通知嗎"));
      } else {
        if (!this.orderDetail.postal_trace_code) {
          alert("請先填寫郵局單號");
          this.sendmailButtonisDisable = false;
          return;
        }
        (url =
          this.$store.getters.getGlobalUrl + `admin/orders/${orderId}/shipped`),
          (userResponse = confirm("您確定要送出出貨通知嗎"));
      }
      if (userResponse) {
        this.sendNoticeAPI(url);
      } else {
        this.sendmailButtonisDisable = false;
      }
    },
    sendNoticeAPI(url) {
      axios({
        url: url,
        method: "patch",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        }
      })
        .then(() => {
          this.sendmailButtonisDisable = false;
          alert("通知信件已寄出");
          (this.isImagefinish = false),
            (this.closeLightbox = true),
            this.getOrder();
        })
        .catch(e => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    },
    deleteOrders() {
      let userResponse = confirm("您確定刪掉此筆訂單嗎?");
      if (userResponse) {
        let deleteOrdersId = [this.$route.params.id].join(",");
        axios({
          // url: "https://private-anon-dce21356cc-goldkingdom.apiary-mock.com/api/admin/orders/id",
          url:
            this.$store.getters.getGlobalUrl + `admin/orders/${deleteOrdersId}`,
          method: "delete",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json"
          }
        })
          .then(() => {
            alert("此筆訂單已刪除");
            this.$router.push("/admin/orderList");
          })
          .catch(e => {
            alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
          });
      }
    },
    goToPrint(index) {
      this.printType = "image";
      let printInfo = {
        id: [this.$route.params.id],
        productIndex: index
      };
      this.$store.dispatch("setPrintInfo", printInfo);
      this.$store.dispatch("setPrintLoading", false);
      this.printPrepare = true;
    },
    async mailInfoPrint() {
      this.printType = "mailInfo";
      this.$store.dispatch("setPrintLoading", false);
      this.printPrepare = true;
      try {
        let res = await this.$store.dispatch("getPrintMailData", {
          id: [this.$route.params.id]
        });
        this.printMailData = this.arrangePrintMailData(res.data);
        this.$store.dispatch("setPrintLoading", true);
      } catch (e) {
        alert(`錯誤訊息：${e}，請重新檢查`);
      }
    },
    arrangePrintMailData(data) {
      //為了要用table排版列印，調整一下格式
      const newArr = [];
      let twoPostCoArray = [];
      for (let i = 0; i < data.length; i = i + 2) {
        if (data[i + 1]) {
          twoPostCoArray = [data[i], data[i + 1]];
        } else {
          twoPostCoArray = [data[i], {}];
        }
        newArr.push(twoPostCoArray);
      }
      return newArr;
    },
    async userUploadFile(e) {
      if (e.target.files.length === 0) {
        return;
      }
      this.uploadBlobData = e.target.files;
      try {
        this.isUploadFileIng = true;
        let response = await this.$store.dispatch("getUploadRemoteData", {
          number: e.target.files.length
        });
        this.uploadRemoteData = response.data;
        this.uploadFileToRemote();
      } catch (e) {
        alert(`錯誤訊息：${e}，請重新檢查`);
      }
    },
    async uploadFileToRemote() {
      let promiseAllRequest = this.uploadRemoteData.put_urls.map(
        function(data, index) {
          let promiseData = axios({
            method: "put",
            url: data,
            data: this.uploadBlobData[`${index}`]
          });
          return promiseData;
        }.bind(this)
      );
      Promise.all(promiseAllRequest).then(
        function(values) {
          let nameData = [...this.finishUploadFileData.fileName];
          for (var i = 0; i < this.uploadBlobData.length; i++) {
            nameData.push(this.uploadBlobData[`${i}`].name);
          }
          this.finishUploadFileData = {
            urls: [
              ...this.finishUploadFileData.urls,
              ...this.uploadRemoteData.urls
            ],
            fileName: nameData
          };
          this.isUploadFileIng = false;
        }.bind(this)
      );
    },
    deleteUserUploadFile() {
      let inputFile = document.querySelector("#upload-file");
      inputFile.value = "";
    },
    deleteUploadFile(index) {
      let userConfirm = confirm("確認刪除檔案嗎？");
      if (!userConfirm) {
        return;
      }
      this.finishUploadFileData.urls.splice(index, 1);
      this.finishUploadFileData.fileName.splice(index, 1);
    },
    async sendLayoutCheckMail() {
      let userConfirm = confirm("確認寄出確認信嗎？");
      if (!userConfirm) {
        return;
      }
      try {
        await this.$store.dispatch("sendLayoutCheckMail", {
          id: this.$route.params.id,
          data: this.finishUploadFileData
        });
        this.closeLightbox = !this.closeLightbox;
        alert("寄出成功");
        this.isImagefinish = false;
        this.getOrder();
      } catch (e) {
        alert(`錯誤訊息：${e}，請重新檢查`);
      }
    },
    async seltPickupFinish() {
      let userConfirm = confirm("確認完成自取嗎？");
      if (userConfirm) {
        try {
          let res = await this.$store.dispatch(
            "pickupSelf",
            this.$route.params.id
          );
          alert("更新成功");
          this.$router.push({ name: "admin_orderList" });
        } catch (e) {
          alert(`錯誤訊息：${e.response.data.message}，請稍後重試`);
        }
      }
    }
  },
  computed: {
    singleProductSum() {
      return function(productPrice, accessoryPrice, amount) {
        if (accessoryPrice === null) {
          return productPrice;
        } else {
          return productPrice + accessoryPrice * amount;
        }
      };
    },
    accessoryTotalPrice() {
      return function(accessoryPrice, amount) {
        if (accessoryPrice === null) {
          return 0;
        } else {
          return accessoryPrice * amount;
        }
      };
    },
    printLoading() {
      return this.$store.getters.getPrintLoading;
    },
    isLayoutConfirmButtonDisplay() {
      if (this.orderDetail.is_check === 1 && this.orderDetail.is_notify !== 1) {
        if (this.orderDetail.is_paid === "1") {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    isShippingNotificationButtonDisplay() {
      if (
        this.orderDetail.is_paid === "1" &&
        this.orderDetail.is_shipped === "0"
      ) {
        if (this.orderDetail.postal_trace_code !== null) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }
};
</script>

<style scoped lang="scss">
* {
  font-size: 17px;
  color: $secondaryDeepColor1;
  box-sizing: border-box;
}
button {
  width: 120px;
  height: 35px;
  border-radius: 2px;
  padding: 0;
  background-color: $secondaryColor3;
}
.bold-word {
  font-weight: 500;
}
.admin-header {
  display: flex;
  align-items: center;
  height: 85px;
  border-bottom: 1px solid $secondaryLightColor1;
  img {
    margin-right: 10px;
  }
  span {
    color: $secondaryLightColor1;
    font-size: 20px;
    letter-spacing: 1.9px;
  }
}
.admin-back {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 66px;
  margin: 0 30px;
  i {
    color: $secondaryDeepColor1;
    margin-right: 10px;
  }
  .btn-container {
    button:not(.last-btn) {
      margin-right: 10px;
    }
    button {
      letter-spacing: 1px;
      color: $secondaryColor3;
      background-color: #4a90e2;
      &:hover {
        background-color: darken(#4a90e2, 10%);
      }
    }
  }
}
#admin-orderDetail-container {
  section:nth-of-type(1) {
    padding-left: 30px;
    padding-right: 30px;
  }
  section:not(:nth-of-type(1)) {
    margin-left: 30px;
    margin-right: 30px;
  }
}
.admin-order-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 58px;
  background-color: #f7f7f8;
  div:first-of-type {
    display: flex;
    div:not(:last-of-type) {
      margin-right: 30px;
    }
  }
  button {
    color: $secondaryColor2;
    border: 1px solid $secondaryColor2;
    &:hover {
      color: $secondaryColor3;
      background-color: $secondaryColor2;
    }
  }
}
.admin-order-info {
  display: flex;
  .flex-item {
    width: 33.333%;
    padding-right: 15px;
    div {
      width: 100%;
    }
  }
  input {
    height: 36px;
    margin-right: 8px;
  }
  button {
    width: 86px;
    color: $secondaryColor3;
    background-color: $secondaryDeepColor1;
    &:hover {
      background-color: darken($secondaryDeepColor1, 10%);
    }
  }
}
.admin-order-list {
  margin-top: 35px;
  .item-button {
    margin-left: 20px;
  }
}
.flex-container {
  display: flex;
  align-items: center;
  // justify-content: space-between;
}
.order-list-title {
  width: 78%;
  padding: 8px 35px;
  display: grid;
  grid-template-columns: 170px 310px 170px 100px 1fr;
  grid-template-rows: 1fr;
  align-items: center;
  border: 1px solid $secondaryLightColor1;
  .quantity-title {
    text-align: center;
  }
  .price-title {
    text-align: right;
  }
}
.order-wrap {
  width: 78%;
  padding: 18px 35px;
  display: grid;
  grid-template-columns: 170px 310px 170px 100px 1fr;
  grid-template-rows: 1fr;
  align-items: center;
  border: 1px solid $secondaryLightColor1;
  border-top: 0;
  .item-img {
    img {
      width: 40px;
      height: auto;
      vertical-align: middle;
    }
  }
  .item-name {
    span {
      display: block;
    }
  }
  .item-quantity {
    text-align: center;
  }
  .item-price {
    text-align: right;
  }
}
.item-button {
  button {
    border: 1px solid $secondaryLightColor1;
    &:hover {
      background-color: #eee;
    }
  }
  button:nth-of-type(1) {
    margin-right: 16px;
  }
}
.total-amount {
  text-align: right;
  width: 78%;
  padding: 18px 35px;
  border: 1px solid $secondaryLightColor1;
  border-top: 0;
  span:last-child {
    font-size: 24px;
    margin-left: 16px;
  }
}
.order-note {
  text-align: left;
  p:first-of-type {
    margin-top: 13px;
  }
}
.lightbox {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  z-index: 1111111;
  .lightbox-target {
    position: absolute;
    left: 0;
    right: 0;
    width: 600px;
    height: 90%;
    overflow: scroll;
    margin: 50px auto;
    background: $secondaryColor3;
    .title {
      margin-top: 0;
      padding: 23px 30px;
      font-weight: 600;
      border-bottom: 1px solid $secondaryLightColor1;
    }
  }
  .lightbox-close {
    position: absolute;
    top: 24px;
    right: 30px;
    cursor: pointer;
  }
  .mail-content-container {
    margin: 0 30px;
    .sent-btn-container,
    .upload-image-btn-container {
      text-align: center;
      margin: 25px 0;
    }
    .no-files-text {
      margin-top: 30px;
      text-align: center;
    }
    .upload-image-container {
      ul {
        padding: 0;
        list-style-type: none;
        margin: 30px;
        li {
          display: flex;
          justify-content: space-between;
          align-items: center;
          .close {
            width: 20px;
            img {
              width: 100%;
            }
          }
        }
      }
    }
    button {
      line-height: 35px;
      padding: 0 15px;
      border-radius: 2px;
      margin: auto;
      letter-spacing: 1px;
    }
    .sent-btn {
      color: $secondaryColor3;
      background-color: #4a90e2;
      &:hover {
        background-color: darken(#4a90e2, 10%);
      }
    }
    .upload-image-btn {
      display: block;
      width: 120px;
      line-height: 35px;
      border-radius: 2px;
      margin: 15px auto;
      letter-spacing: 1px;
      color: $secondaryDeepColor1;
      background-color: $secondaryLightColor1;
      &:hover {
        background-color: darken($secondaryLightColor1, 10%);
      }
    }
    #upload-file {
      display: none;
    }
  }
  .content-container {
    padding: 0 15px;
    border: 1px solid $secondaryLightColor1;
    border-radius: 2px;
    .content-item {
      padding: 20px 0;
      border-bottom: 1px solid $secondaryLightColor1;
      &:last-of-type {
        border-bottom: 0;
      }
    }
  }
}
.displaynone {
  display: none;
}
//loading
.load {
  display: flex;
  justify-content: center;
  align-items: center;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #2275d7;
}
@keyframes loadingC {
  0 {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
//列印設定
#print {
  display: none;
}
#printInvoice {
  display: none;
}
@page {
  size: A4 portrait;
  margin: 0mm;
  // margin-top: 2cm;
  // margin-bottom: 2cm;
  // margin-left: 2cm;
  // margin-right: 2cm;
}

@media print {
  body {
    -webkit-print-color-adjust: exact !important;
  }
  .noprint {
    display: none;
  }
  #print {
    display: block;
  }
  #printInvoice {
    display: block;
  }
}
.admin-header {
  position: relative;
}
.print {
  box-sizing: content-box;
  position: absolute;
  width: 300px;
  height: 35px;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  font-size: 24px;
  text-align: center;
  padding: 50px;
  color: $primaryDeepColor;
  border: 1px $primaryDeepColor solid;
  background-color: $secondaryColor3;
}
.fa-print {
  color: $primaryDeepColor;
}
.admin-back .dontPrint {
  pointer-events: none;
  background-color: rgb(182, 182, 181);
}
</style>
